import React, { useMemo } from 'react';
import { elementSortFn, filterTree } from '../../helpers/elementtree';
import { useToggleExpand } from '../../helpers/groups';
import Layer from './Layer';

export const Layers = (props: any) => {
    const { layers, elements } = props;
    const [expandedGroupIds, toggleGroupExpand] = useToggleExpand([]);

    const layerTree = useMemo(() => {
        return layers.length
            ? filterTree(
                  elements,
                  layers.map((layer: any) => layer.id),
                  (element: any) => {
                      const layer = layers.find((layer: any) => layer.id === element.id);
                      if (layer) {
                          element.disabled = layer.disabled;
                          element.icons = layer.icons;
                      }
                  },
              )
            : {};
    }, [elements, layers]);

    return (
        <div>
            {Object.values(layerTree)
                .sort(elementSortFn())
                .map((layer: any, i) => (
                    <Layer
                        {...props}
                        key={layer.id}
                        layer={layer}
                        expandedGroupIds={expandedGroupIds}
                        toggleGroupExpand={toggleGroupExpand}
                        depth={0}
                    />
                ))}
        </div>
    );
};
